/**
 * User attribute Gender options
 */
export var MoEUserGender;
(function (MoEUserGender) {
    MoEUserGender["MALE"] = "male";
    MoEUserGender["FEMALE"] = "female";
    MoEUserGender["OTHER"] = "other";
})(MoEUserGender || (MoEUserGender = {}));
/**
 * Status of the application.
 */
export var MoEAppStatus;
(function (MoEAppStatus) {
    /**
     * Fresh installation of the app instance.
     */
    MoEAppStatus["INSTALL"] = "install";
    /**
     * App was already present and user has updated the app.
     */
    MoEAppStatus["UPDATE"] = "update";
})(MoEAppStatus || (MoEAppStatus = {}));
/**
 * InApp Action type
 */
export var MoEInAppActionType;
(function (MoEInAppActionType) {
    MoEInAppActionType["NAVIGATION"] = "navigation";
    MoEInAppActionType["CUSTOM"] = "custom";
})(MoEInAppActionType || (MoEInAppActionType = {}));
/**
 * Platform Data
 */
export var MoEPlatform;
(function (MoEPlatform) {
    MoEPlatform["iOS"] = "iOS";
    MoEPlatform["ANDROID"] = "android";
})(MoEPlatform || (MoEPlatform = {}));
/**
 * Supported push services
 */
export var MoEPushService;
(function (MoEPushService) {
    MoEPushService[MoEPushService["APNS"] = 0] = "APNS";
    MoEPushService[MoEPushService["FCM"] = 1] = "FCM";
    MoEPushService[MoEPushService["MI_PUSH"] = 2] = "MI_PUSH";
    MoEPushService[MoEPushService["PUSH_KIT"] = 3] = "PUSH_KIT";
})(MoEPushService || (MoEPushService = {}));
/**
 * Permission Type
 */
export var MoEPermissionType;
(function (MoEPermissionType) {
    MoEPermissionType["PUSH"] = "push";
})(MoEPermissionType || (MoEPermissionType = {}));
/**
 * Nudge Position values
 */
export var MoENudgePosition;
(function (MoENudgePosition) {
    MoENudgePosition["Top"] = "top";
    MoENudgePosition["Bottom"] = "bottom";
    MoENudgePosition["BottomLeft"] = "bottomLeft";
    MoENudgePosition["BottomRight"] = "bottomRight";
    MoENudgePosition["Any"] = "any";
})(MoENudgePosition || (MoENudgePosition = {}));
//# sourceMappingURL=definitions.js.map